/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Resend_Invite_Success_Toast1Inputs */

const en_usermanagement_resend_invite_success_toast1 = /** @type {(inputs: Usermanagement_Resend_Invite_Success_Toast1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite sent successfully!`)
};

/**
* | output |
* | --- |
* | "Invite sent successfully!" |
*
* @param {Usermanagement_Resend_Invite_Success_Toast1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_resend_invite_success_toast1 = /** @type {((inputs?: Usermanagement_Resend_Invite_Success_Toast1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Resend_Invite_Success_Toast1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_resend_invite_success_toast1(inputs)
});
export { usermanagement_resend_invite_success_toast1 as "userManagement_resend_invite_success_toast" }